import _props from '../props'
import initialize from '../Services/initialize'

export default (props) => (dispatch) => {

  _props.set(props)

  dispatch(initialize())
  
}